(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('packagePrice', function(resourceService) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            basePrice: '=',
            flightPrice: '='
        },
        templateUrl: 'partials/home/directivetemplate?type=PackagePrice',
        link(scope) {
            function calcPriceInformation(flightPrice) {
                const priceInformation = {};
                priceInformation.comparison = Math.round(scope.basePrice - flightPrice);
                priceInformation.absolutePrice = Math.abs(priceInformation.comparison);
                priceInformation.divPosition = { top: priceInformation.absolutePrice === 0 ? '3px' : '-6px' };
                scope.sign = priceInformation.comparison > 0 ? '&minus;' : '+';

                switch (true) {
                    case scope.basePrice === 0:
                        //There is no base price to compare to, so comparison text would not make sense.
                        priceInformation.text = '';
                        break;

                    case priceInformation.comparison < 0:
                        priceInformation.text = resourceService.get('ADDITIONAL');
                        break;

                    case priceInformation.comparison === 0:
                        priceInformation.text = resourceService.get('SAMEPRICE');
                        break;

                    case priceInformation.comparison > 0:
                        priceInformation.text = resourceService.get('SAVE');
                        break;

                    case scope.basePrice === undefined:
                        priceInformation.text = 'No base price';
                }

                scope.pi = priceInformation;
                scope.priceExcludesTax = TRPCONFIG.Domain.PriceExcludesTax && scope.pi.absolutePrice !== 0 || false;
            }

            scope.$watch('flightPrice', calcPriceInformation);
        }
    };
});
})();
